import React, {Fragment, useContext, useState} from 'react';
import {
  Button,
  Grid,
  IconButton,
  List, ListItem, ListItemSecondaryAction, ListItemText,
  Typography
} from '@material-ui/core';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {Edit} from '@material-ui/icons';

import {AuthContext} from '../../contexts';
import useListFromFirestoreService
  from '../../helpers/useListFromFirestoreService';
import {PicklistItem} from '../../models';

import {HopEdit, HopView} from '../Hop';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginTop: theme.spacing(3)
  },
}));


const HopsList = () => {
  console.log("Refreshing HopsList");

  const classes = useStyles();

  const [_hopId, setHopId] = useState<string|null>(null);
  const [_editing, setEditing] = useState<boolean>(false);
  const [_selectedIndex, setSelectedIndex] = useState<number|null>(null);

  const {itemLists} = useListFromFirestoreService(
      'beerLists', ['hops'], false);

  const {currentUserRoles} = useContext(AuthContext);
  const canContribute = currentUserRoles?.canContribute;

  const handleAdd = () => {
    setHopId(null);
    setSelectedIndex(null);
    setEditing(true);
  };

  const handleDoneEditing = () => {
    setEditing(false);
    setSelectedIndex(null);
  };

  const handleEdit = (hop: PicklistItem) => {
    if (hop.id != null) {
      setHopId(hop.id);
      setEditing(true);
    }
  };

  const handleSelect = (hop: PicklistItem, index: number) => {
    setSelectedIndex(index);
    setEditing(false);
    hop.id && setHopId(hop.id);
  };

  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography className={classes.title} variant="h2">
          Hops
        </Typography>
        {canContribute &&
          <Button
            size="small"
            color="primary"
            onClick={handleAdd}
          >
            Add
          </Button>
        }
        <List className={classes.root} dense>
          {itemLists.hops && itemLists.hops.map((hop, i) => (
          <Fragment key={i}>
            <ListItem
              divider
              selected={_selectedIndex === i}
              onClick={() => handleSelect(hop, i)}
            >
              <ListItemText
                primary={hop.name}
              />
              {canContribute &&
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={() => handleEdit(hop)}
                  >
                    <Edit/>
                  </IconButton>
                </ListItemSecondaryAction>
              }
            </ListItem>
          </Fragment>
          ))}
        </List>
      </Grid>
      <Grid item xs={6}>
        {_editing
            ? <HopEdit id={_hopId} onComplete={handleDoneEditing}/>
            : <HopView id={_hopId}/>
        }
      </Grid>
    </Grid>
  );
};

export default HopsList;
